import { http } from '.';

class CertificadoService {
    getEventosSubeventos() {
        return http.get('/certificados/form');
    }

    buscarCertificados(dadosBuscar) {
        return http.post('/certificados/buscar-certificados', dadosBuscar);
    }

    buscarCertificadosOuvinte(cpf) {
        return http.post('/certificados/buscar-certificados-ouvinte', { cpf });
    }

    buscarCertificadosComissao(cpf) {
        return http.post('/certificados/buscar-certificados-comissao', { cpf });
    }
}

const certificadoService = new CertificadoService();
export default certificadoService;
